/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef} from "react";
import { loadCSS } from 'fg-loadcss';
import Calendar from "components/Calendar/Calendar.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Slider from "@material-ui/core/Slider";
import clsx from 'clsx';

import axios from "axios";
import { authHeader } from "_helpers";

import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';

import Datetime from 'react-datetime';
import { red } from '@material-ui/core/colors';
// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CardAvatar from "components/Card/CardAvatar.js";
import avatar from "assets/img/faces/marc.jpg";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MailIcon from '@material-ui/icons/Mail';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import HelpIcon from '@material-ui/icons/Help';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';

import TSSelect from "components/Forms/TSSelect";
import TSSelect2 from "components/Forms/TSSelect2";
import IconButton from '@material-ui/core/IconButton';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import TSUser from "components/Forms/TSUser"; 
import TSText from "components/Forms/TSText";
import TSRadio from "components/Forms/TSRadio";
import TSCheckBox from "components/Forms/TSCheckBox";
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import avatar from "assets/img/faces/marc.jpg";
import {
  Input,
  Label,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Modal, ModalBody 
} from "reactstrap";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";

import styled from "styled-components";

const styles = {

};

const primaryColor = "#af2cc5";



const useTreeItemStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.secondary,
    '&:hover > $content': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus > $content, &$selected > $content': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
      color: 'var(--tree-view-color)',
    },
    '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
      backgroundColor: 'transparent',
    },
  },
  content: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '$expanded > &': {
      fontWeight: theme.typography.fontWeightRegular,
    },
  },
  group: {
    marginLeft: 0,
    '& $content': {
      paddingLeft: theme.spacing(2),
    },
  },
  expanded: {},
  selected: {},
  label: {
    fontWeight: 'inherit',
    color: 'inherit',
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    fontWeight: 'inherit',
    flexGrow: 1,
  },
}));


function StyledTreeItem(props) {
  const classes = useTreeItemStyles();
  const { labelText, labelIcon: LabelIcon, labelInfo, txtColor, color, bgColor, nodeType, nodeVal, onTreeClick, ...other } = props;
  

  return (
    <TreeItem
      //onLabelClick={handleClick(nodeType, nodeVal)}
      onLabelClick={onTreeClick}
      label={
        <div className={classes.labelRoot}>
          <LabelIcon color="inherit" className={classes.labelIcon} />
          <Typography variant="body2" className={classes.labelText} style={{color: txtColor}}>
            {labelText}
          </Typography>
          <Typography variant="caption" color="inherit">
            {labelInfo}
          </Typography>
        </div>
      }
      style={{
        '--tree-view-color': color,
        '--tree-view-bg-color': bgColor,
      }}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        selected: classes.selected,
        group: classes.group,
        label: classes.label,
      }}
      {...other}
    />
    );
  }


  StyledTreeItem.propTypes = {
    bgColor: PropTypes.string,
    color: PropTypes.string,
    labelIcon: PropTypes.elementType.isRequired,
    labelInfo: PropTypes.string,
    labelText: PropTypes.string.isRequired,
  };
  
  const useStyles = makeStyles({
    root: {
      flexGrow: 1,
      //maxWidth: 400,
    },
    card: {
      width: 200,
      height:150,
      textAlign: 'center',
      margin: "5px",
      transition: "0.3s",
      display: "inline-block",
      boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
      "&:hover": {
        boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
      }
    },
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "16px",
      marginTop: "10px",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontFamily: '"Sarabun", sans-serif',
      marginBottom: "3px",
      textDecoration: "none"
    },
  });


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    'aria-controls': `scrollable-force-tabpanel-${index}`,
  };
}


const Department = (props) => {
  var moment = require('moment');
  require('moment/locale/th');
  const [tabValue, setTabValue] = React.useState(0);
  const [MeetingKey, setMeetingKey] = useState(null);
  const [MeetingName, setMeetingName] = useState("");
  const [MeetingTypeKey, setMeetingTypeKey] = useState(null);
  const [IsUrgent, setIsUrgent] = useState(false);
  const [StartDate, setStartDate] = useState("");
  const [StartType, setStartType] = useState("");

  const [UserDept, setUserDept] = useState([]);

  const [UserID, setUserID] = useState("");
  const [TitleName, setTitleName] = useState("");
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [NickName, setNickName] = useState("");
  const [Cid, setCid] = useState("");
  const [BirthDT, setBirthDT] = useState("");

  const [Email, setEmail] = useState("");
  const [Gmail, setGmail] = useState("");
  const [GenderKey, setGenderKey] = useState(0);
  const [TypeGovKey, setTypeGovKey] = useState(0);
  
  const [Address, setAddress] = useState("");
  const [Photo, setPhoto] = useState("");
  const [MobilePhone, setMobilePhone] = useState("");
  const [LineNotify, setLineNotify] = useState("");
  const [LineToken, setLineToken] = useState("");





  const [UserDepartmentKey, setUserDepartmentKey] = useState(0);
  const [DepartmentTypeKey, setDepartmentTypeKey] = useState(0);
  const [UserLevelKey, setUserLevelKey] = useState(0);
  const [UserName, setUserName] = useState('');


  const [ArrGroupWork, setArrGroupWork] = useState([]);
  const [ArrDepartment, setArrDepartment] = useState([]);
  const [ArrDepartmentType, setArrDepartmentType] = useState([]);
  const [ArrUserLevel, setArrUserLevel] = useState([]);

  const [ArrTypeGov, setArrTypeGov] = useState([]);



  const [IsMoreDate, setIsMoreDate] = useState(false);
  const [EndDate, setEndDate] = useState("");
  const [EndType, setEndType] = useState("");
  const [MeetingDescription, setMeetingDescription] = useState('');

  const [ContactAddress, setContactAddress] = useState('');
  const [ContactPhone, setContactPhone] = useState('');

  const [modalHoliday, setModalHoliday] = useState(false);
  const [holidayText, setHolidayText] = useState('');
  const [currentDate, setcurrentDate] = useState(moment());
  const [holidays, setHolidays] = useState([]);
  const [Attendee, setAttendee] = useState([]);
  const [emp, setEmp] = useState(null);


  const [toggleEdit, setToggleEdit] = useState(false);

  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [icon2, setIcon2] = useState("far fa-question-circle");

  const [expanded, setExpanded] = React.useState(true);



  const [arrMission, setArrMission] = useState([]);

  const [arrMission2, setArrMission2] = useState([]);

  const [MissionKey, setMissionKey] = useState(0);
  const [GroupWorkKey, setGroupWorkKey] = useState(0);
  const [DepartmentKey, setDepartmentKey] = useState(0);
  const [GroupName, setGroupName] = useState('');
  const [Keyword, setKeyword] = useState('');
  const [Param, SetParam] = useState('');


  const [isOpen, setIsOpen] = useState(false);

  const [dateFocus, setDateFocus] = useState(false);

  const urgentList = [{ label:"ปกติ", value:0}, { label:"ด่วน", value:1} , { label:"ฉุกเฉิน", value:2}];
  const dateTypeList = [{ label:"ทั้งวัน", value:0}, { label:"ครึ่งวันเช้า", value:1} , { label:"ครึ่งวันบ่าย", value:2}];

  const myRef = useRef(null);


  useEffect(() => {
    const node = loadCSS(
      'https://use.fontawesome.com/releases/v6.3.0/css/all.css',
      document.querySelector('#font-awesome-css'),
    );


    axios.get("/api/v1/mission/")
    .then(
      result => {
          if(result.data.result == 200)
          {
            setArrMission(result.data.data)         
            var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"missionKey":').join('"value":'));     
            setArrMission2(json)
          }
        },
        error => {console.log(error); }
    );  

    return () => {
      node.parentNode.removeChild(node);
    };
  }, []);





  const handleKeyword = (val) => {
    //e.preventDefault();
    setKeyword(val);
    var param='?FirstName='+val;
    SetParam(param)


  };

  const handleClickTree = (type, val1, val2, val3, vName, isActive) => (e) => {

    //e.preventDefault();
    //console.log(type)
  
    var param = '';

    setGroupName(vName)
    setIsActive(isActive)
    console.log(isActive)
    if(type == 'M')
    {
      param = 'Mission';
      setMissionKey(val1) 
    }
    else  if(type == 'G')
    {
      setMissionKey(val1) 

      var arrGW = JSON.parse(JSON.stringify(arrMission.filter(e => e.missionKey == val1)[0].groupWork).split('"name":').join('"label":').split('"groupWorkKey":').join('"value":'));     
      setArrGroupWork(arrGW)

      setGroupWorkKey(val2)
      param = 'GroupWork';
    }
    else  if(type == 'D')
    {
      setMissionKey(val1) 

      var arrGW = JSON.parse(JSON.stringify(arrMission.filter(e => e.missionKey == val1)[0].groupWork).split('"name":').join('"label":').split('"groupWorkKey":').join('"value":'));     
      setArrGroupWork(arrGW)

      setGroupWorkKey(val2)
      setDepartmentKey(val3)
      param = 'Department';
    }

    SetParam(param)


  };


  const handleFilterArray = (usr) => (e) => {
    //if(isMultiple)
    {
      //setSelectedUser([...selectedUser, usr]);
      //const filteredArr = arrUser.filter(obj1 => obj1.userName !== usr.userName);
      //setArrUser(filteredArr)     

      //if (props.onChange) {
      //  props.onChange([...selectedUser, usr]);
      //}
    }
    //else
    {
      //setSelectedUser([usr]);

      //if (props.onChange) {
      //  props.onChange([usr]);
      //}

    }


    //if (props.onClick) {
      //props.onClick(e);
      //console.log(selectedUser)
      //setValue(selectedUser);
    //}

  };


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if(GroupName == '')
    {
      cntErr+=1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อกลุ่ม"}</li>);
    }

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal(true);
    }

  };

  

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    var url = ''
    var body = {}

    if(Param == 'Mission')
    {
      url = '/api/v1/mission/'+MissionKey
      body = {name : GroupName}
    }
    else if(Param == 'GroupWork')
    {
      url = '/api/v1/groupwork/'+GroupWorkKey
      body = {name : GroupName, missionKey: MissionKey, isActive: isActive}
    }
    else if(Param == 'Department')
    {
      url = '/api/v1/department/'+DepartmentKey
      body = {name : GroupName, missionKey: MissionKey, groupWorkKey: GroupWorkKey,  isActive: isActive}
      console.log(isActive)
    }


    axios.put(url, body)
    .then(
      result => {
        
        if(result.data.result == 200)
        {

          axios.get("/api/v1/mission/")
          .then(
            result => {
                if(result.data.result == 200)
                {
                  setArrMission(result.data.data)         
                  var json = JSON.parse(JSON.stringify(result.data.data).split('"name":').join('"label":').split('"missionKey":').join('"value":'));     
                  setArrMission2(json)
                }
              },
              error => {console.log(error); }
          );  


          setIcon("far fa-question-circle"); 
          setModal(false) 
          //setModal2(true)
        }
        else
        {
          setIcon("far fa-question-circle"); 
          setModal(false) 
          setErrMsg(result.data.msg)
          setModalError(true) 
        }

      },
      error => {console.log(error);}
    );  

  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleGroupWork = (val) => {
    setMissionKey(val) 
  
    var arrGW = JSON.parse(JSON.stringify(arrMission.filter(e => e.missionKey == val)[0].groupWork).split('"name":').join('"label":').split('"groupWorkKey":').join('"value":'));     
    setArrGroupWork(arrGW)
    console.log(arrGW)
  };

  const handleEmpData = (_val) => {
    //setExpanded(false);
    setToggleEdit(false);
    setEmp(_val[0]);
   

    if(_val != null && _val.length > 0)
    {
       var v = _val[0];

       console.log(v)

       setUserName(v.userName)
       setUserID(v.userID)
       setTitleName(v.titleName)
       setFirstName(v.firstName)
       setLastName(v.lastName)
       setNickName(v.nickName)
       setCid(v.cid)
       setGenderKey(v.genderKey)
       setBirthDT(v.birthDT)
       setMobilePhone(v.mobilePhone)
       setEmail(v.email)
       setGmail(v.gmail)
       setAddress(v.address)
       setTypeGovKey(v.typeGovKey)
       setLineNotify(v.lineNotify)
       setLineToken(v.lineToken)
       setPhoto(v.photo)
       setIsActive(v.isActive)

       axios.get("/api/v1/mission/")
          .then(
            result => {
                if(result.data.result == 200)
                {
                  setUserDept(result.data.data)
                }
              },
              error => {console.log(error); }
          );  
       
     }


 };


  
  const editUser = () => {

     var usr = { 
      titleName: TitleName,
      firstName: FirstName,
      lastName: LastName,
      nickName: NickName,
      cid: Cid,
      birthDT: BirthDT,
      genderKey: GenderKey,
      typeGovKey: TypeGovKey,
      email: Email,
      gmail: Gmail,
      lineNotify: LineNotify,
      lineToken: LineToken,
      photo: Photo,
      address: Address,
      mobilePhone: MobilePhone,
      isActive: isActive,
    };

    axios.put("/api/v1/user/"+UserID, usr)
          .then(
            result => {
                if(result.data.result == 200)
                {
                  alert('บันทึกสำเร็จ')
                  setEmp(null)
                }
              },
              error => {console.log(error); }
          );  


  };

  const editUserDepartment = () => {
    var usrDept = { departmentTypeKey: DepartmentTypeKey, departmentKey:DepartmentKey, userLevelKey:UserLevelKey, userName:UserName };
    axios.put("/api/v1/userdepartment/"+UserDepartmentKey, usrDept)
    .then(
      result => {
          if(result.data.result == 200)
          {
              alert('บันทึกสำเร็จ')

              axios.get("/api/v1/userdepartment/"+UserID)
              .then(
                result => {
                    if(result.data.result == 200)
                    {
                      setUserDept(result.data.data)
                      setToggleEdit(false)
                    }
                  },
                  error => {console.log(error); }
              );  
          }
        },
        error => {console.log(error); }
    );  



  };

  const handleUserDepartment = (userDepartmentKey, departmentTypeKey, departmentKey, userLevelKey, userName) => (e) => {

    setUserDepartmentKey(userDepartmentKey)
    setDepartmentTypeKey(departmentTypeKey)
    setDepartmentKey(departmentKey)
    setUserLevelKey(userLevelKey)
    setUserName(userName)

    setToggleEdit(true);
  };


    const classes = useStyles();


    const renderMission = arrMission.map((mission, index) =>
    <StyledTreeItem onTreeClick={handleClickTree('M', mission.missionKey,0,0, mission.name, false)} nodeType={"M"} nodeVal={mission.missionKey} key={"M"+mission.missionKey.toString()} nodeId={"M"+mission.missionKey.toString()} labelText={mission.name} labelIcon={MailIcon} >
         
         
         {Array.isArray(mission.groupWork)
          ? mission.groupWork.map((group, index2) => 
            <StyledTreeItem onTreeClick={handleClickTree('G', mission.missionKey, group.groupWorkKey,0, group.name, (group.isActive==1))} txtColor={(group.isActive==1)?'':'red'} nodeType={"G"} nodeVal={group.groupWorkKey}  key={"G"+group.groupWorkKey.toString()}  nodeId={"G"+group.groupWorkKey.toString()} labelText={group.name} labelIcon={MailIcon}  >
  
  
                    {Array.isArray(group.department)
                      ? group.department.map((dept, index3) => 
                        <StyledTreeItem onTreeClick={handleClickTree('D',  mission.missionKey, group.groupWorkKey, dept.departmentKey, dept.name, (dept.isActive==1))} txtColor={(dept.isActive==1)?'':'red'} nodeType={"D"} nodeVal={dept.departmentKey} key={"D"+dept.departmentKey.toString()}  nodeId={"D"+dept.departmentKey.toString()} labelText={dept.name} labelIcon={MailIcon} style={{ paddingLeft: '20px'}} >
                    
                        </StyledTreeItem>
                      )
                      : null
                    }
  
  
            </StyledTreeItem>
          )
          : null
        }
    </StyledTreeItem>
    );


    return (

        <div>

            <Grid>

                <Col xs={12} sm={12} md={12}>

                  <Card>
                        <CardHeader color="primary" style={{display:'flex', cursor:'pointer'}} onClick={handleExpandClick}>
                            <h4 className={classes.cardTitleWhite}>โครงสร้างภารกิจ</h4>
                            <p className={classes.cardCategoryWhite}> </p>
                          
                            <CardActions className={classes.collaps}>
                                <IconButton
                                  className={clsx(classes.expand, {
                                    [classes.expandOpen]: expanded,
                                  })}
                                  onClick={handleExpandClick}
                                  aria-expanded={expanded}
                                  aria-label="show more"
                                >
                                  <ExpandMoreIcon />
                                </IconButton>
                            </CardActions>
                            
                        </CardHeader>
                        <CardBody>        
                        <Collapse in={expanded} timeout="auto" unmountOnExit>                  
                            <Grid>
          
                                 
                                <Col xs={12} sm={4} md={4}>
                                    <TreeView
                                      className={classes.root}
                                      defaultExpanded={['3']}
                                      defaultCollapseIcon={<ArrowDropDownIcon />}
                                      defaultExpandIcon={<ArrowRightIcon />}
                                      defaultEndIcon={<div style={{ width: 24 }} />}
                                      //onNodeSelect={handleSelect}
                                    >
                                      {renderMission}
                                  </TreeView>
                                </Col>
                                <Col xs={12} sm={8} md={8} >

                                  <Card>
                                    <CardHeader color="primary">
                                      <p className={classes.cardCategoryWhite}> 
                                      {(Param=='')? "แก้ไขข้อมูลโครงสร้าง" : ""}
                                      {(Param=='Mission')? "แก้ไขชื่อภารกิจ" : ""}
                                      {(Param=='GroupWork')? "แก้ไขกลุ่มงาน" : ""}
                                      {(Param=='Department')? "แก้ไขหน่วยงาน" : ""}
                                      
                                      
                                      </p>
                                      
                                    </CardHeader>
                                    <CardBody> 

                                          {/*
                                          arrUser.map((usr) => (
                                            <></>
                                          ))
                                          */}
                                   
                                     
                             
                                        { (Param == 'Department' || Param == 'GroupWork') ? 
                                         <TSSelect2 fontSize='0.9em'  label="กลุ่มภารกิจ" options={arrMission2} value={MissionKey} onChange={e => handleGroupWork(e.value) } />
                                         : <></>
                                        }  

          
                                        { (Param == 'Department') ? 
                                        <TSSelect2 fontSize='0.9em'  label="กลุ่มงาน" options={ArrGroupWork} value={GroupWorkKey} onChange={e =>setGroupWorkKey(e.value)  } />
                                        : <></>
                                        }  


                                        { (Param == 'Department' || Param == 'GroupWork'|| Param == 'Mission') ? 
                                            <TSText label="ชื่อ" value={GroupName} onChange={e => setGroupName(e.target.value)} />
                                            : <></>
                                        }  


                                        { (Param == 'Department' || Param == 'GroupWork') ? 
                                          <>
                                         {(isActive)? <span style={{ color: 'green' }} >เปิดการใช้งานอยู่ </span>  :<span style={{ color: 'red' }}>ปิดการใช้งานไปแล้ว </span>  }<TSCheckBox checked={isActive} onChange={e => setIsActive(!isActive) } />
                                         </>
                                         : <></>
                                        }  


               
               
                                       { (Param == '') ? 
                                          <>กรุณาเลือกภารกิจ, กลุ่มงาน หรือ หน่วยงานที่จะแก้ไข</>
                                        :  
                                          <Col xs={12} sm={12} md={12} style={{marginTop:'20px', textAlign:'center'}} >
                                            <Button
                                              color="primary"
                                              type="button"
                                              onClick={handleSubmit}
                                              disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                            >
                                              <h4>ยืนยัน</h4>
                                            </Button>
    
                                            <Button
                                              color="primary"
                                              type="button"
                                              onClick={() => setToggleEdit(false)}
                                            >
                                              <h4>ยกเลิก</h4>
                                            </Button>
                                          </Col>
                                        }     

                                    </CardBody>
                                  </Card >

                                </Col>

                            </Grid>
                        </Collapse>  
                      </CardBody>
                      <CardFooter>
                          <Collapse isOpen={isOpen}>

                          </Collapse>
                          {/* Confirm */}
                          <Modal toggle={() => setModal(false)} isOpen={modal}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={icon}
                                  style={{ color: "blue", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center"
                                }}
                              >
                                {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                                  ? "ยืนยันการบันทึกข้อมูล"
                                  : "กำลังตรวจสอบข้อมูล"}
                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
        
                              <Button
                                color="primary"
                                type="button"
                                onClick={handleConfirm}
                                disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                              >
                                <h4>ยืนยัน</h4>
                              </Button>

                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModal(false)}
                              >
                                <h4>ยกเลิก</h4>
                              </Button>

                            </div>
                          </Modal>

                          {/* Success */}
                          <Modal toggle={() => setModal2(false)} isOpen={modal2}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className={"fas fa-check"}
                                  style={{ color: "green", fontSize: "4em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p
                                style={{
                                  textAlign: "center", fontSize: "1.8em"
                                }}
                              >
                               บันทึกข้อมูลสำเร็จ

                              </p>
                              <p> </p>
                            </ModalBody>
                            <div className="modal-footer">
                              <Button
                                color="info"
                                type="button"
                                onClick={() => { setModal2(false);}}
                              >
                                <i className={"fa fa-thumbs-up"} style={{ fontSize: "1.8em", padding:"0 5px 5px 0" }}></i>
                                <h4>ตกลง</h4>
                              </Button>

                             
                            </div>
                          </Modal>           

                          {/* Error */}
                          <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                            <div className="modal-header justify-content-center">
                              <div>
                                <i
                                  className="fa fa-times"
                                  style={{ color: "red", fontSize: "2em" }}
                                ></i>
                              </div>
                            </div>
                            <ModalBody>
                              <p>ไม่สามารถบันทึกข้อมูลได้</p>
                              <div>{errMsg}</div>
                            </ModalBody>
                            <div className="modal-footer justify-content-center">
                              <Button
                                color="primary"
                                type="button"
                                onClick={() => setModalError(false)}
                              >
                                <h4>ตกลง</h4>
                              </Button>
                            </div>
                          </Modal>
                      </CardFooter>
                  </Card>
                
                </Col>


               {emp != null ?
               <Col xs={12} sm={12} md={12}>

               <Card>
                     <CardAvatar profile>
                       <a href="#pablo" onClick={(e) => e.preventDefault()}>
                       <img src={'https://e.trangskin.go.th/avatar/'+emp.userName+'.jpg'} style={{width: 120, height: 120, borderRadius: 120/2, objectFit: 'cover', objectPosition: '100% 0'}} />
                       </a>      
                                         
                     </CardAvatar>
                     <CardBody profile>      
                       <h5 className={classes.cardTitle}> {emp != null ? emp.firstName+' '+emp.lastName:''}</h5>    
                       <h5 className={classes.cardTitle}> {UserName}</h5>    
                     <AppBar position="static" color="default">

                         <Tabs
                           value={tabValue}
                           onChange={handleTabChange}
                           variant="scrollable"
                           scrollButtons="on"
                           indicatorColor="primary"
                           textColor="primary"
                           aria-label="scrollable force tabs example"
                         >
                           <Tab label="ข้อมูลส่วนบุคคล" icon={<Icon className="fa fa-circle-info" />} {...a11yProps(0)} />
                           <Tab label="ต้นสังกัด" icon={<FavoriteIcon />} {...a11yProps(1)} />
                           {/* 
                           <Tab label="Item Three" icon={<PersonPinIcon />} {...a11yProps(2)} />
                           <Tab label="Item Four" icon={<HelpIcon />} {...a11yProps(3)} />
                           <Tab label="Item Five" icon={<ShoppingBasket />} {...a11yProps(4)} />
                           <Tab label="Item Six" icon={<ThumbDown />} {...a11yProps(5)} />
                           <Tab label="Item Seven" icon={<ThumbUp />} {...a11yProps(6)} />
                           */}
                         </Tabs>
                       </AppBar>
                       <TabPanel value={tabValue} index={0}>       
                         <Grid>
           
                             <Col xs={12} sm={4} md={3} lg={3} xl={2}>
                               <TSText label="คำนำหน้า" defaultValue={TitleName} value={TitleName} onChange={e => setTitleName(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={4} md={3} lg={3} xl={2}>
                               <TSText label="ชื่อ" value={FirstName} onChange={e => setFirstName(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={4} md={3} lg={3} xl={2}>
                               <TSText label="สกุล" value={LastName} onChange={e => setLastName(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={4} md={3} lg={3} xl={2}>
                               <TSText label="ชื่อเล่น" value={NickName} onChange={e => setNickName(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={4} md={4}  lg={4} xl={2} >
                               <TSText label="เลขบัตรประจำตัวประชาชน" value={Cid} onChange={e => setCid(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={4} md={4} lg={4} xl={2}>
                               <TSText label="เพศ" value={GenderKey} onChange={e => setGenderKey(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                               <TSText label="ว/ด/ป เกิด" value={BirthDT} onChange={e => setBirthDT(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                               <TSText label="โทรศัพท์" value={MobilePhone} onChange={e => setMobilePhone(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                               <TSText label="Email" value={Email} onChange={e => setEmail(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={6} md={4} lg={4} xl={3}>
                               <TSText label="Gmail" value={Gmail} onChange={e => setGmail(e.target.value)} />
                             </Col>
                   
                             <Col xs={12} sm={12} md={12}>
                                 <div className="textarea-container" style={{ padding: 0 }}>
                                       <Label for="Address">ที่อยู่ </Label>  
                                           {/*(อ้างอิงจากที่อยู่ตอนลงทะเบียน, สามารถแก้ไขที่อยู่จัดส่งได้)*/}
                                       <Input
                                           id="Address"
                                           cols="80"
                                           name="Address"
                                           placeholder="ที่อยู่"
                                           rows="4"
                                           type="textarea"
                                           className="custom"
                                           style={{ fontSize: '1.2em', maxHeight: '150px' }}
                                           value={Address}
                                           onChange={e => setAddress(e.target.value) }
                                           ></Input>
                                   </div>
                             </Col>
                             <Col xs={12} sm={4} md={3}>
                               <TSSelect2 fontSize='1em' label="ประเภทเจ้าหน้าที่" options={ArrTypeGov} value={TypeGovKey} onChange={e => setTypeGovKey(e.value) } />
                             </Col>
                             <Col xs={12} sm={4} md={3}>
                               <TSText label="LineNotify" value={LineNotify} onChange={e => setLineNotify(e.target.value)} />
                             </Col>

                             <Col xs={12} sm={4} md={3}>
                               <TSText label="LineBot" value={LineToken} onChange={e => setLineToken(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={12} md={3}>
                               <TSText label="รูป" value={Photo} onChange={e => setPhoto(e.target.value)} />
                             </Col>
                             <Col xs={12} sm={12} md={4}>
                               <TSText label="เปิดใช้งาน" value={isActive} onChange={e => setIsActive(e.target.value)} />
                             </Col>

                             <Col xs={12} sm={12} md={12} style={{textAlign:'center'}} >

                               <Button
                                 style={{maxWidth: '400px;'}}
                                 color="primary"
                                 type="button"
                                 onClick={editUser}
                                 disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                               >
                                 <h4>บันทึก</h4>
                               </Button>

                             </Col>
                         </Grid>

                       </TabPanel>
                       <TabPanel value={tabValue} index={1}>
                  

                           {(toggleEdit)? 
                           
                           <Grid>
                             <Col xs={12} sm={12} md={2} lg={4}> &nbsp; </Col>
                             <Col xs={12} sm={12} md={8} lg={4}> 
                                 <Grid>
                                   <Col xs={12} sm={12} md={12}>
                                     <input type='hidden' value={UserDepartmentKey}></input>
                                     <TSSelect2 fontSize='0.9em' label="ประเภทโครงสร้าง" options={ArrDepartmentType} value={DepartmentTypeKey} onChange={e => setDepartmentTypeKey(e.value) } />
                                   </Col>
                                   <Col xs={12} sm={12} md={12}>
                                     <TSSelect2 fontSize='0.9em'  label="หน่วยงาน" options={ArrDepartment} value={DepartmentKey} onChange={e => setDepartmentKey(e.value) } />
                                   </Col>
                                   <Col xs={12} sm={12} md={12}>
                                     <TSSelect2 fontSize='0.9em'  label="ระดับ" options={ArrUserLevel} value={UserLevelKey} onChange={e => setUserLevelKey(e.value) } />
                                   </Col>

                                   <Col xs={12} sm={12} md={12} >

                                       <Button
                                         color="primary"
                                         type="button"
                                         onClick={editUserDepartment}
                                         disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                                       >
                                         <h4>ยืนยัน</h4>
                                       </Button>

                                       <Button
                                         color="primary"
                                         type="button"
                                         onClick={() => setToggleEdit(false)}
                                       >
                                         <h4>ยกเลิก</h4>
                                       </Button>

                                   </Col>

                                 </Grid>
                             </Col>
                             <Col xs={12} sm={12} md={2} lg={4}>  &nbsp;  </Col>
                           </Grid>

                             
                           :

                           <Table className={classes.table} aria-label="simple table" >
                             <TableHead>
                               <TableRow>
                                 <TableCell>ประเภทโครงสร้าง</TableCell>
                                 <TableCell>หน่วยงาน</TableCell>
                                 <TableCell>กลุ่มงาน</TableCell>
                                 <TableCell>กลุ่มภารกิจ</TableCell>
                                 <TableCell>ระดับ</TableCell>
                                 <TableCell style={{ width: 200 }}></TableCell>
                               </TableRow>
                             </TableHead>
                             <TableBody>
                               {UserDept.map((row) => (
                                 <>
                                 <TableRow key={1}>
                                   <TableCell component="th" scope="row">{row.departmentType.name}</TableCell>
                                   <TableCell component="th" scope="row">{row.department.name}</TableCell>
                                   <TableCell component="th" scope="row">{row.department.groupWork.name}</TableCell>
                                   <TableCell component="th" scope="row">{row.department.groupWork.mission.name}</TableCell>
                                   <TableCell component="th" scope="row">{row.userLevel.name}</TableCell>
                                   <TableCell component="th" scope="row">
                                     <Icon style={{color:'blue'}} className="fa fa-edit" onClick={handleUserDepartment(row.userDepartmentKey, row.departmentTypeKey, row.departmentKey,row.userLevelKey, row.userName)} /></TableCell>
                                 </TableRow>
                               </>
                               ))}
                             </TableBody>
                           </Table>
           
                           }



                       </TabPanel>

                       {/* 
                       <TabPanel value={tabValue} index={2}>
                         Item Three
                       </TabPanel>
                       <TabPanel value={tabValue} index={3}>
                         Item Four
                       </TabPanel>
                       <TabPanel value={tabValue} index={4}>
                         Item Five
                       </TabPanel>
                       <TabPanel value={tabValue} index={5}>
                         Item Six
                       </TabPanel>
                       <TabPanel value={tabValue} index={6}>
                         Item Seven
                       </TabPanel>
                       */}
                         
                     </CardBody>
                     
                   <CardFooter>
                       <Collapse isOpen={isOpen}>
                       </Collapse>
                       {/* Confirm */}
                       <Modal toggle={() => setModal(false)} isOpen={modal}>
                         <div className="modal-header justify-content-center">
                           <div>
                             <i
                               className={icon}
                               style={{ color: "blue", fontSize: "2em" }}
                             ></i>
                           </div>
                         </div>
                         <ModalBody>
                           <p
                             style={{
                               textAlign: "center"
                             }}
                           >
                             {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                               ? "ยืนยันการบันทึกข้อมูล"
                               : "กำลังตรวจสอบข้อมูล"}
                           </p>
                           <p> </p>
                         </ModalBody>
                         <div className="modal-footer">
                           <Button
                             color="primary"
                             type="button"
                             onClick={() => setModal(false)}
                           >
                             <h4>ยกเลิก</h4>
                           </Button>

                           <Button
                             color="primary"
                             type="button"
                             onClick={handleConfirm}
                             disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                           >
                             <h4>ยืนยัน</h4>
                           </Button>
                         </div>
                       </Modal>

                       {/* Error */}
                       <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                         <div className="modal-header justify-content-center">
                           <div>
                             <i
                               className="fa fa-times"
                               style={{ color: "red", fontSize: "2em" }}
                             ></i>
                           </div>
                         </div>
                         <ModalBody>
                           <p>ไม่สามารถบันทึกข้อมูลได้</p>
                           <div>{errMsg}</div>
                         </ModalBody>
                         <div className="modal-footer justify-content-center">
                           <Button
                             color="primary"
                             type="button"
                             onClick={() => setModalError(false)}
                           >
                             <h4>ตกลง</h4>
                           </Button>
                         </div>
                       </Modal>
                   </CardFooter>
               </Card>

           </Col>
               :

               <></>
               
               }                   

                





              
            </Grid>
        </div>
    );
}
export default Department;